import React from 'react';
const ToastContext = React.createContext({
    add: () => { return ''; },
    remove: () => { },
});
ToastContext.displayName = 'ToastContext';
export default ToastContext;
//# sourceMappingURL=context.js.map